import { Vector2 } from "three";
export function createDashedTracer(path, bakedRules) {
    const strokeLength = bakedRules.strokeLength ?? 0;
    const strokeSpacing = bakedRules.strokeSpacing ?? 0;
    const strokeWidth = bakedRules.strokeWidth ?? 0;
    const strokeDashes = Math.round(path.getLength() / (strokeLength + strokeSpacing));
    const shape = [
        new Vector2(strokeLength * -0.5, strokeWidth * +0.5),
        new Vector2(strokeLength * +0.5, strokeWidth * +0.5),
        new Vector2(strokeLength * +0.5, strokeWidth * -0.5),
        new Vector2(strokeLength * -0.5, strokeWidth * -0.5),
    ];
    const dashes = [];
    try {
        const dashPositions = path.getSpacedPoints(strokeDashes);
        const dashBasis = path.computeFrenetFrames(strokeDashes, true);
        // Omit last dash to avoid overlapping dashes at start and end of shape
        for (let i = 0; i < dashPositions.length - 1; i++) {
            const position = dashPositions[i];
            const tangent = dashBasis.tangents[i];
            if (position && tangent) {
                const angle = Math.atan2(tangent.y, tangent.x);
                dashes.push({
                    position,
                    angle,
                });
            }
        }
    }
    catch {
        // An exception is likely thrown from computeFrenetFrames(..) due to a degenerate path. A degenerate
        // path should return "zero geometry" and for that reason, an empty dashes array is returned
    }
    return {
        dashes,
        shape,
    };
}
//# sourceMappingURL=dashedTracer.js.map